export const ADMIN_STAFF_ROLES = ['super_admin', 'user_manager', 'support', 'viewer'];
export const ADMIN_PERMISSIONS = [
    'users:read',
    'users:lock',
    'users:unlock',
    'users:reset_password',
    'users:delete',
    'users:update_role',
    'admins:manage',
    'audit:read',
    'therapists:read',
    'therapists:verify',
    'sessions:moderate',
    'refunds:issue',
    'reports:generate',
    'content:manage',
    'translations:manage',
    'expansion:manage',
    'hmo:manage',
    'dashboard:read',
    'backups:manage',
];
export const ROLE_PERMISSIONS = {
    super_admin: ADMIN_PERMISSIONS,
    user_manager: [
        'users:read',
        'users:lock',
        'users:unlock',
        'users:reset_password',
        'users:delete',
        'users:update_role',
        'audit:read',
        'therapists:read',
        'dashboard:read',
    ],
    support: [
        'users:read',
        'users:lock',
        'users:unlock',
        'users:reset_password',
        'audit:read',
        'therapists:read',
        'dashboard:read',
    ],
    viewer: ['users:read', 'audit:read', 'therapists:read', 'dashboard:read'],
};
export function getPermissionsForRole(role) {
    return [...ROLE_PERMISSIONS[role]];
}
export function hasAdminPermission(role, permission) {
    if (!role)
        return false;
    return ROLE_PERMISSIONS[role].includes(permission);
}
//# sourceMappingURL=rbac.js.map